import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';

const MessageInput = ({ onSendMessage, onImageUpload }) => {
  const [message, setMessage] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);

  const handleSend = () => {
    if (message?.trim()) {
      onSendMessage(message);
      setMessage('');
      inputRef?.current?.focus();
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSend();
    }
  };

  const handleFileSelect = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      onImageUpload?.(file);
    }
  };

  return (
    <div 
      className="bg-white px-4 py-3 border-t border-gray-200"
    >
      <div className="flex items-end gap-2 max-w-[1100px] mx-auto">
        {/* Emoji Button */}
        <button
          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0"
          title="Emoji"
        >
          <Icon name="Smile" size={24} className="text-gray-500" />
        </button>

        {/* Attachment Button */}
        <button
          onClick={() => fileInputRef?.current?.click()}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0"
          title="Dosya ekle"
        >
          <Icon name="Paperclip" size={24} className="text-blue-600" />
        </button>
        <input
          ref={fileInputRef}
          type="file"
          className="hidden"
          accept="image/*,video/*"
          onChange={handleFileSelect}
        />

        {/* Message Input */}
        <div className="flex-1 relative">
          <textarea
            ref={inputRef}
            value={message}
            onChange={(e) => setMessage(e?.target?.value)}
            onKeyPress={handleKeyPress}
            placeholder="Bir mesaj yazın"
            rows="1"
            className="w-full px-4 py-2.5 rounded-lg resize-none outline-none text-[15px]"
            style={{
              backgroundColor: '#f0f2f5',
              color: '#111b21',
              maxHeight: '120px',
              minHeight: '42px'
            }}
          />
        </div>

        {/* Send/Voice Button */}
        {message?.trim() ? (
          <button
            onClick={handleSend}
            className="p-2.5 bg-blue-600 text-white rounded-full transition-all hover:scale-110 hover:bg-blue-700 flex-shrink-0"
            title="Gönder"
          >
            <Icon name="Send" size={20} className="text-white" />
          </button>
        ) : (
          <button
            className="p-2.5 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0"
            title="Sesli mesaj"
          >
            <Icon name="Mic" size={24} className="text-gray-500" />
          </button>
        )}
      </div>
    </div>
  );
};

export default MessageInput;